import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./schema";

console.log({ baseUrl: import.meta.env.VITE_API_URL });

const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.VITE_API_URL,
  credentials: "include",
  // headers: {
  //   get [SSE_CONNECTION_ID_HEADER]() {
  //     return getSseConnectionId() ?? "";
  //   },
  // },
  // @ts-expect-error type mismatch
  fetch: (...args) => window.interceptedFetch?.(...args) || fetch(...args),
});

/**
 * Secondary fetch client targeting the worker/heavy-task server.
 * Falls back to VITE_API_URL when VITE_API_WORKER_URL is not set.
 */
const workerFetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.VITE_API_WORKER_URL || import.meta.env.VITE_API_URL,
  credentials: "include",
  // @ts-expect-error type mismatch
  fetch: (...args) => window.interceptedFetch?.(...args) || fetch(...args),
});

export const $api = createClient(fetchClient);

export { fetchClient, workerFetchClient };
